import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/(auth)/reset-password/page.tsx");
